module.exports = __webpack_public_path__ + "static/img/header.458e5482.png";